import {
	SGCContainer,
	SGCDescription,
	SGCIcon,
	SGCImage,
	SGCPrice,
	SGCPriceButton,
	SGCPriceDescription,
	SGCPurchasedBadge,
	SGCPurchasedBadgeDate,
	SGCPurchasedBadgeTitle,
	SGCTitle,
} from "./ShopGoodCart.styled";
import { getIconInstrumentById, getShopGoodAccessState, renderActionShopButton } from "../../../helpers";
import { observer } from "mobx-react";
import { useStores } from "../../../stores";
import { ShopGoodStore } from "../../../stores/shop";
import { API } from "../../../core";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ShopGoodAccessStatus } from "../../../constants";

interface GoodCardProps {
	shopGoodStore: ShopGoodStore;
}

export const ShopGoodCart = observer(({ shopGoodStore }: GoodCardProps) => {
	const { settingsStore, authStore, stripeStore, promoCodeStore } = useStores();

	const accessState = getShopGoodAccessState(shopGoodStore, authStore.userStore.active_shop_orders);
	const isDisabledBuy = accessState.status !== ShopGoodAccessStatus.Available;

	const isFree = ["Free"].includes(shopGoodStore.rate);

	const { t } = useTranslation();

	const { id, title, instrument_id, price_dollar, price_ruble, cover } = shopGoodStore;

	const navigate = useNavigate();

	const price = settingsStore.lang === "ru" ? price_ruble : price_dollar;
	const currency = settingsStore.lang === "ru" ? "₽" : "$";

	const getPrice = () => {
		const locale = settingsStore.lang === "ru" ? "ru-RU" : "en-EN";

		let finalPrice = price;

		if (promoCodeStore.isActive && promoCodeStore.discount > 0) {
			finalPrice = price * (1 - promoCodeStore.discount / 100);
		}

		return new Intl.NumberFormat(locale, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		}).format(finalPrice);
	};

	const handleOnBuy = async () => {
		if (!authStore.isAuth) {
			navigate("/sign/login");
			return;
		}

		if (isDisabledBuy) {
			return;
		}

		if (settingsStore.lang !== "ru") {
			const sessionId = await stripeStore.checkoutSession({
				shop_good_id: shopGoodStore.id,
				promo_code: promoCodeStore.promoCode,
			});

			if (sessionId && stripeStore.instance) {
				await stripeStore.instance.redirectToCheckout({ sessionId });
			}

			return;
		}

		// Продамус
		const link = await API.request<string>(`shop/invoice`, {
			method: "POST",
			body: API.getFormData({
				shop_good_id: id,
				promo_code: promoCodeStore.promoCode,
			}),
		});

		// Открываем получаемую ссылку
		window.open(link, "_blank");
	};

	console.log("ShopGoodCart accessState", shopGoodStore.id, accessState.status, accessState);

	return (
		<SGCContainer>
			<SGCImage>
				{cover && <img src={cover} alt={title} />}

				{/*{!cover && <img src="/images/shop-good/default-shop-good.png" alt={title} />}*/}
			</SGCImage>

			<SGCTitle>
				<SGCIcon>{getIconInstrumentById(instrument_id)}</SGCIcon>
				{title}
			</SGCTitle>

			<SGCDescription>{shopGoodStore.description}</SGCDescription>

			<SGCPrice>
				{currency}
				{getPrice()}
			</SGCPrice>

			<SGCPriceDescription>per month, blled monthly</SGCPriceDescription>

			{renderActionShopButton({
				accessState,
				isFree,
				t,
				onBuy: handleOnBuy,
				ButtonBuyComponent: SGCPriceButton,
				PurchasedPlanBadgeComponent: SGCPurchasedBadge,
				PurchasedPlanDateComponent: SGCPurchasedBadgeDate,
			})}
		</SGCContainer>
	);
});
